import { Component, OnInit } from '@angular/core';
import { SortformsService } from "./sortforms.service";
import { Router } from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PasswordModalComponent } from '../password-modal/password-modal.component';
import { CloneTemplateComponent } from "./clone-template/clone-template.component";
import { FormService } from "../form/form.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from '../services/shared.service';
import * as _ from 'lodash'
import { CloneTemplateOrganizationComponent } from './clone-template-organization/clone-template-organization.component';
import { CookieService } from 'ngx-cookie-service';
import { OrganizationService } from '../organizations/organization.service';
import { FormSharingService } from '../services/form-sharing.service';

@Component({
  selector: 'app-sortforms',
  templateUrl: './sortforms.component.html',
  styleUrls: ['./sortforms.component.scss']
})
export class SortformsComponent implements OnInit {

  templates: any = undefined;
  archivedTemplates: any = undefined;
  deletedTemplates: any = undefined;
  userPriveleges = [];
  bgTextColor = "#000000";
  isArchived: Boolean = false;
  isDeleted: Boolean = false;
  organizations: Array<any> = [];

  constructor(
    public dialog: MatDialog,
    private _sortFormService: SortformsService,
    private _router: Router,
    private _formService: FormService,
    private _snackBar: MatSnackBar,
    private _sharedService: SharedService,
    private _cookieService: CookieService,
    private _organizationsService: OrganizationService,
    public _sharingService: FormSharingService
  ) { }

  ngOnInit(): void {
    this.onInit();
  }

  onInit(): void {
    // Get user privelges
    this._sharedService.getPrivileges(localStorage.getItem('role')).subscribe((response) => {
      if (response['success']) {
        this.userPriveleges = response['data'][0]['privileges'];
      }
    });
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    // Get all templates
    this._sortFormService.getAllTemplates(localStorage.getItem('organization')).subscribe((response) => {
      if (response['success']) {
        this.templates = response['data'];
        this.templates.forEach((template: { sharing: { url_link: { is_active: any; }; }; is_url_active: boolean; }) => {
          if (template.sharing && template.sharing.url_link && template.sharing.url_link.is_active) {
            template.is_url_active = true;
          } else {
            template.is_url_active = false;
          }
        });
        const defaultTempaltes = _.filter(this.templates, (template) => {
          if (template && template['is_default'] && template['is_default'] == true) {
            return true;
          }
          return false;
        })

        this.templates = _.filter(this.templates, (template) => {
          if (template && template['is_default'] && template['is_default'] == true) {
            return false;
          }
          return true;
        })

        this.templates.splice(0, 0, ...defaultTempaltes)
      }
    }, (error) => {
      console.error(error);
    });

    // Check if super admin
    if (this._cookieService.get("super_admin") === "true") {
      this._organizationsService.getAllOrganizations().subscribe((response: any) => {
        if (response['success']) {
          this.organizations = response['data'];
        }
      })
    }
  }

  editForm(templatedIndex, type) {
    let formDetails = this.templates[templatedIndex];
    if (formDetails['is_default'] == true) {
      return;
    }
    if (type === 'archived') {
      let templateId = this.archivedTemplates[templatedIndex]["_id"];
      this._router.navigate(["form-builder"], { queryParams: { id: templateId } });
    } else if (type === 'deleted') {
      let templateId = this.deletedTemplates[templatedIndex]["_id"];
      this._router.navigate(["form-builder"], { queryParams: { id: templateId } });
    } else {
      let templateId = this.templates[templatedIndex]["_id"];
      this._router.navigate(["form-builder"], { queryParams: { id: templateId } });
    }
  }

  archiveTemplate(index, type) {
    this._sharedService.confirmationDialog("Are you sure you want to archive the form?", () => {
      let requestData = {};
      if (type === 'deleted') {
        requestData = {
          templateId: this.deletedTemplates[index]["_id"]
        };
      } else {
        requestData = {
          templateId: this.templates[index]["_id"]
        };
      }

      this._sortFormService.archiveTemplate(requestData).subscribe(response => {
        if (response["success"]) {
          this.openSnackBar(response["message"]);
          if (type === 'deleted') {
            this.deletedTemplates.splice(index, 1);
          } else {
            this.templates.splice(index, 1);
          }
        }
      }, (error) => {
        console.log(error);
      })
    });
  }

  deleteTemplate(index, type) {
    this._sharedService.confirmationDialog("Are you sure you want to delete the form?", () => {
      let requestData = {};

      if (type === 'archived') {
        requestData = {
          templateId: this.archivedTemplates[index]["_id"]
        };
      } else {
        requestData = {
          templateId: this.templates[index]["_id"]
        };
      }

      this._sortFormService.deleteTemplate(requestData).subscribe(response => {
        if (response["success"]) {
          this.openSnackBar(response["message"]);
          if (type === 'archived') {
            this.archivedTemplates.splice(index, 1);
          } else {
            this.templates.splice(index, 1);
          }
        }
      }, (error) => {
        console.log(error);
      })
    });
  }

  getiFrameLink(templateId) {
    return "<iframe src=" + this.getHostName() + "/form-preview?id=" + templateId + " width='1280' height='960'>"
  }

  getHostName() {
    // return document.location.protocol + '//' + document.location.hostname + '/';
    return document.location.protocol + '//' + window.location.host + '/';
  }
  copyEmbedLink(templateId) {
    var copyText = document.getElementById("embed-text-" + templateId) as HTMLInputElement;
    copyText.select();
    document.execCommand("copy");
    this.openSnackBar("Embeddable link copied to clipboard");
  }

  cloneTemplate(template) {
    const dialogRef = this.dialog.open(CloneTemplateComponent, {
      data: {
        "copyOf": template.name
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result["rename"]) {
        // Creating request object
        let requestData = {
          name: result["value"],
          code: this.generateRandomCode(),
          organization: localStorage.getItem('organization'),
          updated_at: Date.now(),
          is_archived: false,
          is_embeddable: false,
          auth_required: false,
          embed_link: "",
          hashed_password: "",
          salt: "",
          template_schema: template.template_schema,
          templateId: template._id
        };

        // API call
        this._formService.saveTemplate(requestData).subscribe((response) => {
          if (response['success']) {
            this.onInit();
          } else {
            this.openSnackBar(response["message"]);
          }
        });
      }
    });
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }

  generateRandomCode() {
    let randomString = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let charactersLength = characters.length;
    for (let i = 0; i < 11; i++) {
      randomString += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return randomString;
  }

  openPasswordDialog(template) {
    const dialogRef = this.dialog.open(PasswordModalComponent, {
      data: {
        "id": template["_id"],
        "type": "setpassword"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._sortFormService.setPasswordToTemplate({ password: result.password, templateId: result.templateId }).subscribe((response) => {
          this.onInit();
          this.openSnackBar("Set password successful");
        }, (error) => {
          console.error(error);
        });
      }
    });
  }

  onReloadClick(): void {
    this.onInit();
  }

  activateTemplate(templateId, type, index) {
    let requestData = {
      templateId: templateId,
      type: type
    };

    this._sortFormService.activateTemplate(requestData).subscribe((response) => {
      if (response["success"]) {
        if (type === "web") {
          this.templates[index]["is_active"] = true;
        } else {
          this.templates[index]["is_active_app"] = true;
        }
        this.openSnackBar(response["message"]);
      } else {
        this.openSnackBar("Server side error occcurred")
      }
    }, (error) => {
      console.log(error);
      this.openSnackBar("Server side error occcurred")
    })
  }

  deactivateTemplate(templateId, type, index) {
    let requestData = {
      templateId: templateId,
      type: type
    };

    this._sortFormService.deactivateTemplate(requestData).subscribe((response) => {
      if (response["success"]) {
        if (type === "web") {
          this.templates[index]["is_active"] = false;
        } else {
          this.templates[index]["is_active_app"] = false;
        }
        this.openSnackBar(response["message"]);
      } else {
        this.openSnackBar("Server side error occcurred")
      }
    }, (error) => {
      console.log(error);
      this.openSnackBar("Server side error occcurred")
    });
  }

  onSliderChange(templateId, index, type) {
    if (!type) {
      if (this.templates[index]["is_url_active"]) {
        this._sharingService.deactivateURL(templateId, index, this.templates);
      } else {
        this._sharingService.activateURL(templateId, index, this.templates);
      }
    } else if (type === "web") {

      if (this.templates[index]["is_active"]) {
        this.deactivateTemplate(templateId, type, index);
      } else {
        this.activateTemplate(templateId, type, index);
      }
    } else {
      if (this.templates[index]["is_active_app"]) {
        this.deactivateTemplate(templateId, type, index);
      } else {
        this.activateTemplate(templateId, type, index);
      }
    }
  }

  checkPrivilege(accessType) {
    return this._sharedService.checkPrivilege(this.userPriveleges, accessType);
  }

  getArchivedTemplates() {
    this.archivedTemplates = undefined;
    this.isArchived = true;
    this.isDeleted = false;
    this._sortFormService.getArchivedTemplates(localStorage.getItem('organization')).subscribe((response) => {
      if (response["success"]) {
        this.archivedTemplates = response["data"];
      } else {
        this.openSnackBar(response["message"]);
      }
    }, (error) => {
      this.openSnackBar("Server side error occurred");
    });
  }

  getDeletedTemplates() {
    this.deletedTemplates = undefined;
    this.isArchived = false;
    this.isDeleted = true;
    this._sortFormService.getDeletedTemplates(localStorage.getItem('organization')).subscribe((response) => {
      if (response["success"]) {
        this.deletedTemplates = response["data"];
      } else {
        this.openSnackBar(response["message"]);
      }
    }, (error) => {
      this.openSnackBar("Server side error occurred");
    });
  }

  restoreArchivedTemplate(index) {
    this._sharedService.confirmationDialog("Are you sure you want to restore the form?", () => {
      this._sortFormService.restoreArchivedTemplate({ templateId: this.archivedTemplates[index]._id }).subscribe((response) => {
        if (response["success"]) {
          this.archivedTemplates.splice(index, 1);
          this.openSnackBar(response["message"]);
        } else {
          this.openSnackBar(response["message"]);
        }
      }, (error) => {
        this.openSnackBar("Server side error occurred");
      });
    });
  }

  restoreDeletedTemplate(index) {
    this._sharedService.confirmationDialog("Are you sure you want to restore the form?", () => {
      this._sortFormService.restoreDeletedTemplate({ templateId: this.deletedTemplates[index]._id }).subscribe((response) => {
        if (response["success"]) {
          this.deletedTemplates.splice(index, 1);
          this.openSnackBar(response["message"]);
        } else {
          this.openSnackBar(response["message"]);
        }
      }, (error) => {
        this.openSnackBar("Server side error occurred");
      });
    });
  }

  navToSortForms() {
    this.isArchived = false;
    this.isDeleted = false;
    this.templates = undefined;
    this.onInit();
  }

  openPreview(templateId) {
    let url = this.getHostName() + "form-preview?id=" + templateId + "&preview=true";
    window.open(url, '_blank');
  }

  copyFormEmbedLink(template) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    if (template.is_embeddable) {
      selBox.value = template.embed_link;
    } else {
      selBox.value = `<iframe src="${this.getHostName()}/form-preview?id=${template._id}" style="width: 95vw; height: 95vh;"></iframe>`
    }
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    // this.embeddable_link = selBox.value;
    document.body.removeChild(selBox);
    // this.isEmbeddable = true;
    this.openSnackBar("Embeddable link copied to clipboard");
  }

  copyFormURLLink(template) {
    this._sharingService.copyFormURLLink(template);
  }

  cloneFormToOtherOrg(template) {
    this.dialog.open(CloneTemplateOrganizationComponent, {
      data: {
        form: template,
        organizations: _.cloneDeep(this.organizations)
      }
    })
  }
}
